export default __webpack_public_path__ + "static/media/team14.210c1bba.JPG";